<template>
  <main class="app-container">
    <page-content :page_key="pageKey" container="page"></page-content>
  </main>
</template>

<script>

    import PageContent from "../components/PageContent.vue";
export default {
  name: "page",
  components: {
      PageContent,
  },
    data() {
      return {
          pageKey:this.$route.params.pageKey
      }
    },
    created() {

    },
};
</script>


<style lang="scss" scoped>


</style>
